module.exports = __webpack_public_path__ + "img/home-v2-1.2c7ece6c.jpg";